// Locale-aware number formatters shared by the dashboard summary cards
// and breakdown table.

// Formats an integer with the user's locale grouping separator
// (e.g. 5000 -> "5,000" in en-US, "5.000" in de-DE).
// Returns '' for null/undefined so the call site doesn't need to null-check.
export const formatInt = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return '';
  return value.toLocaleString();
};

// Formats a float with the user's locale separators and a fixed number of
// fractional digits (default 1). Returns '' for null/undefined.
export const formatFloat = (
  value: number | null | undefined,
  digits = 1
): string => {
  if (value === null || value === undefined) return '';
  return value.toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};
